export default class AppInfo {
  constructor (data) {
    this.name = data.name;
    this.description = data.description;
    this.platform = data.platform;
    this.bundleId = data.bundleId;
  }
}
